import { render } from "./OfficesGeneral.vue?vue&type=template&id=54321b1c"
import script from "./OfficesGeneral.vue?vue&type=script&lang=js"
export * from "./OfficesGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rnedkov/Documents/GitHub/cleaner-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__